import { render, staticRenderFns } from "./curationUsersDetailPage.vue?vue&type=template&id=21bb86f0&scoped=true&"
import script from "./curationUsersDetailPage.vue?vue&type=script&lang=js&"
export * from "./curationUsersDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bb86f0",
  null
  
)

export default component.exports